module.exports = new __parcel__URL__("upload.606d348b.svg").toString();